<template>
    <main>
        <div class="main">
            <div class="detail">
                <div class="left">
                    <h1>{{details.name}}</h1>
                    <h2>{{details.position}}</h2>
                    <img :src="details.img">
                    <h3>{{details.unit}}</h3>
                    <p>{{details.description}}</p>
                </div>
                <div class="right">
                    <div class="top">
                        <h2>专家介绍</h2>
                        <div class="introduction" v-html="introduction"></div>
                    </div>
                    <div class="bottom">
                        <h2>专家课程</h2>
                        <div>
                            <h1>
                                {{course.name}}
                            </h1>
                            <p class="tip">内容概要:</p>
                            <p class="course" v-html="course.content"></p>
                            <a href="javascript: void 0;" class="btn" @click.stop="toVideoDetails(course.videoId)">课程详情</a>
                            <span class="date">{{course.time}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>
<script>
    export default {
        name: 'ExperteDetails',
        created() {
            this.getExperteDetails();
        },
        data() {
            return {
                details: {},
                introduction: '',
                course: {},
            }
        },
        methods: {
            getExperteDetails() {
                const experteId = this.$route.query.experteId;
                const params = {
                    experteId: experteId,
                }
                this.$api.getExperteDetails(params).then(r => {
                    if (r.code === 1) {
                        this.details = r.data.details;
                        this.introduction = r.data.introduction;
                        this.course = r.data.course;
                    }
                })
            },
            toVideoDetails(id) {
                const src="/teachingvideo/videos?videoId="+id;
                let newpage = this.$router.resolve({
                    path: src,
                })  
                window.open(newpage.href, '_blank');
            },
        },
    }
</script>
<style lang="scss" scoped>
    @import '../ExperteList.scss';
</style>